import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { icons } from '../../../assets';
// eslint-disable-next-line
export const UserPerfilCemexVrl = ({ grupo, nameUser, matricula, Fecha_y_hora }) => {
    const { arrayData } = useSelector((state) => state.table);
    const { typeAdmin } = useSelector((state) => state.auth)
    // const [pointsUpper, setpointsUpper] = useState(0)
    const [progress, setprogress] = useState(0)
    const [timeTotalUser, setTimeTotalUser] = useState(0)
    const { proyectSelected } = useSelector((state) => state.vrlSlice);
    const { proyects } = useSelector((state) => state.vrlSlice);
    const [pageSelected, setpageSelected] = useState(0)

    const { responses } = useSelector((state) => {
        if (typeAdmin === "VRT") {
            return state.vrtSlice
        }
        else {
            return state.vrlSlice
        }
    });
    // eslint-disable-next-line
    const [dataFilterPerUser, setFileterData] = useState([])
    const [generalData, setgeneralData] = useState({
        errors: 0,
        time: 0,
        gems: 0
    })

    const convertToSeconds = (tiempo_total) => {
        const [value, unit] = tiempo_total.split(" ");
        const numValue = parseInt(value, 10);

        if (isNaN(numValue)) {
            throw new Error("Formato inválido para tiempo_total");
        }

        switch (unit.toLowerCase()) {
            case "seg":
            case "segundos":
            case "s":
                return numValue;
            case "min":
            case "minutos":
            case "m":
                return numValue * 60;
            case "horas":
            case "hora":
            case "h":
                return numValue * 3600;
            default:
                throw new Error(`Unidad no reconocida: ${unit}`);
        }
    };

    const formatedDate = (date, tiempo_total = "0 s") => {
        const fecha = new Date(date);
        fecha.setSeconds(fecha.getSeconds() + convertToSeconds(tiempo_total));
        return fecha.toLocaleString('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        });
    }


    const userStatusprogress = (dataFilterPerUser) => {
        if (dataFilterPerUser.length > 0) {
            const lessonKeys = Object.keys(dataFilterPerUser[0]).filter(key => key.startsWith("M") && key.includes("_L"));

            const answeredLessons = lessonKeys.filter(key => dataFilterPerUser[0][key].correct > 0 || dataFilterPerUser[0][key].incorrect > 0).length;

            const percentageAnswered = (answeredLessons / 20) * 100;

            setprogress(dataFilterPerUser.length ? percentageAnswered.toFixed(0) : 0);
        }
        else {
            setprogress(0);
        }

    }
    // const userHighPoints = (dataFilterPerUser) => {
    //     if (dataFilterPerUser.length > 0) {
    //         // Ponderación de los módulos
    //         const weights = {
    //             M1: 0.15,
    //             M2: 0.20,
    //             M3: 0.45,
    //             M4: 0.20
    //         };

    //         // Inicializar el porcentaje total
    //         let totalPercentage = 0;

    //         // Calcular el porcentaje de cada módulo
    //         for (const [module, weight] of Object.entries(weights)) {
    //             // Filtrar las lecciones correspondientes al módulo actual
    //             const lessons = Object.keys(dataFilterPerUser[0]).filter(key => key.startsWith(module));

    //             // Contar las respuestas correctas del módulo
    //             const correctAnswers = lessons.reduce((sum, lesson) => {
    //                 return sum + (dataFilterPerUser[0][lesson].correct || 0);
    //             }, 0);
    //             // Sumar al porcentaje total
    //             totalPercentage += Math.min((correctAnswers / (lessons.length - 1)) * weight * 100, weight * 100);
    //         }
    //         setpointsUpper(dataFilterPerUser.length ? totalPercentage.toFixed(0) : 0);
    //     }
    //     else {
    //         setpointsUpper(0)
    //     }
    // }

    const userTimeTotal = (dataFilterPerUser) => {
        let sumtime = 0
        dataFilterPerUser.forEach(element => {
            sumtime += parseInt(element.tiempo_total)
        })
        const timeInMinutes = sumtime

        const hrs = Math.floor(timeInMinutes / 60);
        const mins = Math.floor(timeInMinutes % 60);
        const secs = Math.floor((timeInMinutes % 1) * 60);

        const formatoTiempo = `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;

        setTimeTotalUser(formatoTiempo);
    }

    const onSetDefaultPointsMAxim = (obj) => {
        const objU = obj[0]
        // Obtener todas las claves relevantes del objeto
        const keys = Object.keys(objU)
            .filter(key => key.match(/^M\d+_L\d+$/)) // Filtrar solo las claves que correspondan a Mx_Ly
            .sort((a, b) => {
                const [am, al] = a.match(/^M(\d+)_L(\d+)$/).slice(1).map(Number);
                const [bm, bl] = b.match(/^M(\d+)_L(\d+)$/).slice(1).map(Number);
                return am - bm || al - bl; // Ordenar por módulo ascendente, luego por lección ascendente
            });

        // Encontrar el último Mx_Ly con al menos un punto en correct o incorrect
        let lastIndex = -1;
        for (let i = 0; i < keys.length; i++) {
            const { correct, incorrect } = objU[keys[i]];
            if (correct > 0 || incorrect > 0) {
                lastIndex = i;
            }
        }

        // Rellenar correct=1 en los anteriores si tienen 0 en correct
        for (let i = 0; i <= lastIndex; i++) {
            const lesson = objU[keys[i]];
            if (lesson.correct === 0) {
                lesson.correct = 1;
            }
        }

        // Establecer correct=0 en los posteriores
        for (let i = lastIndex + 1; i < keys.length; i++) {
            const lesson = objU[keys[i]];
            lesson.correct = 0;
        }

        return [objU];
    }


    const onchangePage = (next) => {
        setpageSelected(actual => {
            const suma = actual + next
            if (suma >= dataFilterPerUser.length) {
                return 0
            }
            if (suma <= -1) {
                return dataFilterPerUser.length - 1
            }
            else {
                return suma
            }

        })
    }

    useEffect(() => {

        // if (typeAdmin === "VRT" && proyectSelected === "66fafd1d92bbc20883798c43") {
        // console.log(arrayData)
        let sumintents = 0
        const conjunts = arrayData.reduce((acc, curr) => {
            // Verificar si la matrícula es igual a la que estamos evaluando

            if (curr.matricula === matricula) {
                console.log(curr)

                const fecha = curr.Fecha_y_hora.split("T")[0];
                const key = `${curr.matricula}-${fecha}`;
                if (!acc[key]) {
                    console.log(formatedDate(curr.Fecha_y_hora))
                    console.log(curr.Fecha_y_hora)
                    acc[key] = {
                        Nombre: curr.Nombre,
                        Fecha_y_hora: curr.Fecha_y_hora,
                        tiempo_total: curr.tiempo_total.split(' ')[0],
                        Porcentaje_total: curr.Porcentaje_total,
                        matricula: curr.matricula,
                        puntaje: curr.puntaje,
                        errors: 0,
                        initialDate: formatedDate(curr.Fecha_y_hora),
                        endDate: formatedDate(curr.Fecha_y_hora),
                        finalDatePlusTimeTotal: formatedDate(curr.Fecha_y_hora, curr.tiempo_total),
                        M1: 0,
                        M2: 0,
                        M3: 0,
                        M4: 0,
                        M1_L1: { correct: 0, incorrect: 0 },
                        M1_L2: { correct: 0, incorrect: 0 },
                        M1_L3: { correct: 0, incorrect: 0 },
                        M1_L4: { correct: 0, incorrect: 0 },
                        M1_L5: { correct: 0, incorrect: 0 },
                        M1_L6: { correct: 0, incorrect: 0 },
                        M2_L1: { correct: 0, incorrect: 0 },
                        M2_L2: { correct: 0, incorrect: 0 },
                        M2_L3: { correct: 0, incorrect: 0 },
                        M2_L4: { correct: 0, incorrect: 0 },
                        M2_L5: { correct: 0, incorrect: 0 },
                        M3_L1: { correct: 0, incorrect: 0 },
                        M3_L2: { correct: 0, incorrect: 0 },
                        M3_L3: { correct: 0, incorrect: 0 },
                        M3_L4: { correct: 0, incorrect: 0 },
                        M4_L1: { correct: 0, incorrect: 0 },
                        M4_L2: { correct: 0, incorrect: 0 },
                        M4_L3: { correct: 0, incorrect: 0 },
                        M4_L4: { correct: 0, incorrect: 0 },
                        M4_L5: { correct: 0, incorrect: 0 },
                    };
                }
                for (let keyLocal of ["M1_L1", "M1_L2", "M1_L3", "M1_L4", "M1_L5", "M1_L6", "M2_L1", "M2_L2", "M2_L3", "M2_L4", "M2_L5", "M3_L1", "M3_L2", "M3_L3", "M3_L4", "M4_L1", "M4_L2", "M4_L3", "M4_L4", "M4_L5"]) {
                    if (curr[keyLocal] === "True") {
                        acc[key][keyLocal].correct += 1;

                    } else {
                        if (curr[keyLocal] !== "*" && curr[keyLocal]) {
                            acc[key][keyLocal].incorrect += 1;
                            acc[key].errors += 1;
                        }
                    }
                }

                // acc[key].tiempo_total += parseInt(curr.tiempo_total.split(' ')[0]);
                // Comparar y guardar el puntaje más alto
                const currPuntaje = parseInt(curr.puntaje.split("/")[0], 10);
                const accPuntaje = parseInt(acc[key].puntaje.split("/")[0], 10);
                if (currPuntaje > accPuntaje) {
                    acc[key].puntaje = curr.puntaje;
                }
                const currPorcent = parseInt(curr.Porcentaje_total.split("%")[0], 10);
                const accPorcent = parseInt(acc[key].Porcentaje_total.split("%")[0], 10);
                if (currPorcent > accPorcent) {
                    acc[key].Porcentaje_total = curr.Porcentaje_total;
                }
                // if (new Date(curr.Fecha_y_hora) < new Date(acc[key].initialDate)) {

                //     acc[key].initialDate = formatedDate(curr.Fecha_y_hora);
                // }
                // if (new Date(curr.Fecha_y_hora) < new Date(acc[key].endDate)) {

                //     acc[key].endDate = formatedDate(curr.Fecha_y_hora);
                // }
            }

            return acc;
        }, {});
        const arrayConjunt = Object.values(conjunts);
        arrayConjunt.forEach(element => {
            for (let keyLocal of ["M1_L1", "M1_L2", "M1_L3", "M1_L4", "M1_L5", "M1_L6", "M2_L1", "M2_L2", "M2_L3", "M2_L4", "M2_L5", "M3_L1", "M3_L2", "M3_L3", "M3_L4", "M4_L1", "M4_L2", "M4_L3", "M4_L4", "M4_L5"]) {
                // console.log("------")
                if ((element[keyLocal].correct + element[keyLocal].incorrect) > element[keyLocal.substring(0, 2)]) {
                    element[keyLocal.substring(0, 2)] = element[keyLocal].correct + element[keyLocal].incorrect
                }
                // console.log(element)
            }
        })
        const arrayCon = onSetDefaultPointsMAxim(arrayConjunt)
        // console.log("*******")
        // promedios 
        console.log(arrayConjunt)
        console.log(sumintents)


        let infogeneral = {
            errors: 0,
            time: 0,
            gems: 0
        }
        arrayConjunt.forEach(element => {
            infogeneral.errors += element.errors
            infogeneral.time += parseInt(element.tiempo_total)
            infogeneral.gems += parseInt(getGems(element, ["M1_L1", "M1_L2", "M1_L3", "M1_L4", "M1_L5", "M1_L6"]).split("/")[0])
            infogeneral.gems += parseInt(getGems(element, ["M2_L1", "M2_L2", "M2_L3", "M2_L4", "M2_L5"]).split("/")[0])
            infogeneral.gems += parseInt(getGems(element, ["M3_L1", "M3_L2", "M3_L3", "M3_L4"]).split("/")[0])
            infogeneral.gems += parseInt(getGems(element, ["M4_L1", "M4_L2", "M4_L3", "M4_L4", "M4_L5"]).split("/")[0])
        })
        setgeneralData(infogeneral)
        setFileterData(arrayConjunt);
        // userHighPoints(arrayCon);
        userStatusprogress(arrayCon);
        userTimeTotal(arrayCon)
        // eslint-disable-next-line 
    }, [responses, proyectSelected, arrayData, Fecha_y_hora, matricula, typeAdmin, nameUser])


    const getGems = (secction, steaps) => {
        if (!secction) {
            return "0/0"
        }
        let corrects = 0
        steaps.forEach((steap) => {
            if (secction[`${steap}`].correct >= 1) {
                corrects++
            }
        })
        if (corrects === steaps.length) {
            return `3/3`
        }
        if (corrects >= steaps.length / 2) {
            return `2/3`
        }
        if (corrects >= 1) {
            return `1/3`
        }
        return `0/3`

    }

    return (
        <div className='w-full h-full max-h-[90vh] flex flex-col py-6 px-10 overflow-y-auto'>
            <div className=' w-full h-5/12 flex items-center'>
                <div className='w-10 h-10 rounded-full flex justify-center items-center bg-blue-600 mr-4'>
                    <p className='text-white font-semibold text-xs'> {nameUser.split(" ")[0].substring(0, 2).toUpperCase()}</p>
                </div>
                <InfoUser title={"Nombre"} text={nameUser} />
                <InfoUser title={"Matrícula"} text={matricula} />
                {proyectSelected._id === "672e4328031ac03e79f58508" && <InfoUser title={"Fecha y hora de registro"} text={formatedDate(Fecha_y_hora) !== "Invalid Date" ? formatedDate(Fecha_y_hora) : "Sin fecha"} />}
            </div>
            <div className="pt-6">
                <p className='text-black text-base font-semibold leading-5'>{proyects.find(proyect => proyect._id === proyectSelected._id).name}</p>
            </div>
            <div className='w-full h-20 flex justify-start gap-x-8 py-3'>
                <div className='h-16 pr-4 border-r border-[#686868]'>
                    <p className='pb-2'>Totales</p>
                    <div className='flex justify-start gap-x-8'>
                        <div className='flex'>
                            <img src={icons.watch} className='h-6 w-6' alt="icon time total" />
                            <div className='pl-2'>
                                <p className='text-xs text-[#686868] leading-5'>Tiempo total</p>
                                <p className='text-sm font-medium text-[#282828] leading-5'>{timeTotalUser} hrs.</p>
                            </div>
                        </div>
                        <div className='flex'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M9.75 9.75L14.25 14.25M14.25 9.75L9.75 14.25M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z" stroke="#686868" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <div className='pl-2'>
                                <p className='text-xs text-[#686868] leading-5'>Errores Totales</p>
                                <p className='text-sm font-medium text-[#282828] leading-5'>{generalData.errors}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=' '>
                    <p className='pb-2'>Promedios</p>
                    <div className='flex justify-start gap-x-8'>
                        <div className='flex'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M9.75 9.75L14.25 14.25M14.25 9.75L9.75 14.25M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z" stroke="#686868" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <div className='pl-2'>
                                <p className='text-xs text-[#686868] leading-5'>Errores promedio</p>
                                <p className='text-sm font-medium text-[#282828] leading-5'>{generalData.errors / dataFilterPerUser.length}</p>
                            </div>
                        </div>
                        <div className='flex'>
                            <img src={icons.watch} className='h-6 w-6' alt="icon time total" />
                            <div className='pl-2'>
                                <p className='text-xs text-[#686868] leading-5'>Tiempo promedio</p>
                                <p className='text-sm font-medium text-[#282828] leading-5'>{generalData.time / dataFilterPerUser.length} min.</p>
                            </div>
                        </div>
                        <div className='flex'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z" stroke="#686868" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M15.4615 9H8.53846L7 10.5556L12 16L17 10.5556L15.4615 9Z" stroke="#686868" strokeWidth="1.5" strokeLinejoin="round" />
                                <path d="M12 12V13" stroke="#686868" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <div className='pl-2'>
                                <p className='text-xs text-[#686868] leading-5'>Gemas promedio</p>
                                <p className='text-sm font-medium text-[#282828] leading-5'>{generalData.gems / dataFilterPerUser.length}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='pl-8 pt-6'>
                <p className='text-base'><strong>Repeticiones por curso</strong> ({dataFilterPerUser.length})</p>
            </div>
            <div className="w-full flex justify-center items-center pt-4">
                {
                    dataFilterPerUser.length >= 2 &&
                    <div
                        onClick={() => { onchangePage(-1) }}
                        className='h-full flex justify-center items-center mr-4 cursor-pointer'>
                        <div className='w-10 h-10 rounded-lg shadowBtnNext flex justify-center items-center'>
                            <img src={icons.mayorqueicon} className='h-6 transform rotate-180' alt="" />
                        </div>
                    </div>
                }
                {/*  */}
                <div className='w-[744px] h-[392px] rounded-3xl shadow-3xl py-8 px-4'>
                    <div className='flex justify-center w-full gap-4 pb-4'>
                        {/* <div className='flex gap-2'>
                            <img src={icons.initialDate} className="w-6 h-6" alt="icono de fecha" />
                            <div>
                                <p className='text-[#686868]'>Fecha inicial</p>
                                <p>{dataFilterPerUser[pageSelected]?.initialDate || 'Sin fecha'}</p>
                            </div>
                        </div> */}
                        <InfoIntent icon={icons.initialDate} title={'Fecha inicial'} data={dataFilterPerUser[pageSelected]?.initialDate || 'Sin fecha'}></InfoIntent>
                        <InfoIntent icon={icons.endDate} title={'Última sesión'} data={dataFilterPerUser[pageSelected]?.finalDatePlusTimeTotal || 'Sin fecha'}></InfoIntent>
                        <div className='flex gap-2'>
                            <img src={icons.progress} className="w-6 h-6" alt="icono de fecha" />
                            <div>
                                <p className='text-[#686868] text-xs font-medium '>Estatus</p>
                                <div className='w-[112px] text-[#9A9A9A] text-xs font-normal leading-5'>
                                    <p className='w-[112px] text-center leading-5 py-1'>{progress + '%' || 'Sin progreso'}</p>
                                    <div className='w-full h-1 bg-[#d9d9d9] rounded'>
                                        <div
                                            style={{ width: progress + '%' || '0%' }}
                                            className={`h-full ${progress < 100 ? 'bg-[#F2B840]' : 'bg-[#89EB7E]'} `}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className='flex gap-2'>
                            <img src={icons.progress} className="w-6 h-6" alt="icono de fecha" />
                            <div>
                                <p className='text-[#686868] text-xs font-medium '>Puntaje</p>
                                <div className='w-[112px] text-[#9A9A9A] text-xs font-normal leading-5'>
                                    <p className='w-[112px] text-center leading-5 py-1'>{pointsUpper + "/100" || 'Sin puntaje'}</p>
                                    <div className='w-full h-1 bg-[#d9d9d9] rounded'>
                                        <div
                                            style={{ width: pointsUpper ? pointsUpper + '%' || '0%' : "0%" }}
                                            className={`h-full ${pointsUpper < 100 ? 'bg-[#F2B840]' : 'bg-[#89EB7E]'} `}></div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        {/* <InfoIntent icon={icons.progress} title={'Progreso'} data={dataFilterPerUser[pageSelected]?.Porcentaje_total || 'Sin progreso'}></InfoIntent> */}
                        {/* <InfoIntent icon={icons.pointsSheld} title={'Puntaje'} data={dataFilterPerUser[pageSelected]?.puntaje || 'Sin puntaje'}></InfoIntent> */}
                    </div>
                    <div className='w-full h-10 bg-3366FF rounded flex'>
                        <div className='w-3/12 flex justify-start items-center px-2'>
                            <p className='text-white font-bold text-xs'>Módulos</p>
                        </div>
                        <div className='w-5/12 flex justify-start items-center'>
                            <p className='text-white font-bold text-xs'>Pasos (# repetición por tarea)</p>
                        </div>
                        <div className='w-2/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>
                            <p className='text-white font-bold text-xs'>Errores</p>
                        </div>
                        {/* <div className='w-3/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>
                            <p className='text-white font-bold text-xs'>Tiempo</p>
                        </div> */}
                        <div className='w-2/12 flex justify-center items-center'>
                            <p className='text-white font-bold text-xs'>Gemas</p>
                        </div>
                    </div>
                    {/* epp */}
                    <div className='w-full flex py-2'>
                        <div className='w-3/12 flex justify-start items-center px-2'>
                            <p className='text-xs font-medium text-[#686868]'>EPP</p>
                        </div>
                        <div className='w-5/12'>
                            <div className='flex flex-wrap gap-2 w-[160px]'>
                                <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M1_L1'}></CubeSteap>
                                <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M1_L2'}></CubeSteap>
                                <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M1_L3'}></CubeSteap>
                                <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M1_L4'}></CubeSteap>
                                <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M1_L5'}></CubeSteap>
                                <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M1_L6'}></CubeSteap>
                                <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                                <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                                <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                                <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>

                            </div>
                        </div>
                        <div className='w-2/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>
                            {dataFilterPerUser[pageSelected]?.M1_L1.incorrect +
                                dataFilterPerUser[pageSelected]?.M1_L2.incorrect +
                                dataFilterPerUser[pageSelected]?.M1_L3.incorrect +
                                dataFilterPerUser[pageSelected]?.M1_L4.incorrect +
                                dataFilterPerUser[pageSelected]?.M1_L5.incorrect +
                                dataFilterPerUser[pageSelected]?.M1_L6.incorrect
                            }
                        </div>
                        {/* <div className='w-3/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>{dataFilterPerUser[pageSelected]?.tiempo_total / 4} min.</div> */}
                        <div className='w-2/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>
                            {/* {dataFilterPerUser[pageSelected] ? dataFilterPerUser[pageSelected]?.M1_L1.incorrect >= 1 ? "2/3" : '3/3' : "0/3"} */}
                            {getGems(dataFilterPerUser[pageSelected], ["M1_L1", "M1_L2", "M1_L3", "M1_L4", "M1_L5", "M1_L6"])}
                        </div>
                    </div>
                    {/* previo a utilizar  */}
                    <div className='w-full flex py-2 bg-[#68686810]'>
                        <div className='w-3/12 flex justify-start items-center px-2'>
                            <p className='text-xs font-medium text-[#686868]'>Previo a utilizar canalones</p>
                        </div>
                        <div className='w-5/12 flex flex-wrap gap-2'>
                            {/* <div className={`w-8 h-8 rounded-lg flex justify-center items-center text-white font-semibold ${dataFilterPerUser[pageSelected]?.M2_L1.incorrect >= 1 ? "bg-[#DF3C3C]" : "bg-[#89EB7E]"}`}>
                                {dataFilterPerUser[pageSelected] ? dataFilterPerUser[pageSelected].M2_L1.correct + dataFilterPerUser[pageSelected].M2_L1.incorrect : 'X'}
                            </div> */}
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M2_L1'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M2_L2'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M2_L3'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M2_L4'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M2_L5'}></CubeSteap>

                        </div>
                        <div className='w-2/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>
                            {dataFilterPerUser[pageSelected]?.M2_L1.incorrect +
                                dataFilterPerUser[pageSelected]?.M2_L2.incorrect +
                                dataFilterPerUser[pageSelected]?.M2_L3.incorrect +
                                dataFilterPerUser[pageSelected]?.M2_L4.incorrect +
                                dataFilterPerUser[pageSelected]?.M2_L5.incorrect
                            }
                        </div>
                        {/* <div className='w-3/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>{dataFilterPerUser[pageSelected]?.tiempo_total / 4} min.</div> */}
                        <div className='w-2/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>
                            {getGems(dataFilterPerUser[pageSelected], ["M2_L1", "M2_L2", "M2_L3", "M2_L4", "M2_L5"])}
                        </div>
                    </div>
                    {/* despliegue */}
                    <div className='w-full flex py-2'>
                        <div className='w-3/12 flex justify-start items-center px-2'>
                            <p className='text-xs font-medium text-[#686868]'>Despliegue inicial</p>
                        </div>
                        <div className='w-5/12 flex flex-wrap gap-2'>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M3_L1'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M3_L2'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M3_L3'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M3_L4'}></CubeSteap>
                            <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                        </div>
                        <div className='w-2/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>
                            {dataFilterPerUser[pageSelected]?.M3_L1.incorrect +
                                dataFilterPerUser[pageSelected]?.M3_L2.incorrect +
                                dataFilterPerUser[pageSelected]?.M3_L3.incorrect +
                                dataFilterPerUser[pageSelected]?.M3_L4.incorrect
                            }
                        </div>
                        {/* <div className='w-3/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>{dataFilterPerUser[pageSelected]?.tiempo_total / 4} min.</div> */}
                        <div className='w-2/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>
                            {getGems(dataFilterPerUser[pageSelected], ["M3_L1", "M3_L2", "M3_L3", "M3_L4"])}
                        </div>
                    </div>
                    {/*  */}
                    <div className='w-full flex py-2 bg-[#68686810]'>
                        <div className='w-3/12 flex justify-start items-center px-2'>
                            <p className='text-xs font-medium text-[#686868]'>Plegar al final de la descarga</p>
                        </div>
                        <div className='w-5/12 flex flex-wrap gap-2'>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M4_L1'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M4_L2'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M4_L3'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M4_L4'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M4_L5'}></CubeSteap>
                        </div>
                        <div className='w-2/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>
                            {dataFilterPerUser[pageSelected]?.M4_L1.incorrect +
                                dataFilterPerUser[pageSelected]?.M4_L2.incorrect +
                                dataFilterPerUser[pageSelected]?.M4_L3.incorrect +
                                dataFilterPerUser[pageSelected]?.M4_L4.incorrect +
                                dataFilterPerUser[pageSelected]?.M4_L5.incorrect
                            }
                        </div>
                        {/* <div className='w-3/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>{dataFilterPerUser[pageSelected]?.tiempo_total / 4} min.</div> */}
                        <div className='w-2/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>
                            {getGems(dataFilterPerUser[pageSelected], ["M4_L1", "M4_L2", "M4_L3", "M4_L4", "M4_L5"])}
                        </div>
                    </div>
                    <div className='bg-686868 h-10 w-full rounded-b-lg flex items-center'>
                        <p className='w-3/12 text-xs pl-4 text-white leading-5'>Total</p>
                        <div className='w-5/12'></div>
                        <p className='w-2/12 text-xs text-center text-white leading-5'>{dataFilterPerUser[pageSelected]?.errors}</p>
                        {/* <p className='w-3/12 text-xs text-center text-white leading-5'>{dataFilterPerUser[pageSelected]?.tiempo_total}</p> */}
                        <p className='w-2/12 text-xs text-center text-white leading-5'>
                            {
                                parseInt(getGems(dataFilterPerUser[pageSelected], ["M1_L1", "M1_L2", "M1_L3", "M1_L4", "M1_L5", "M1_L1"]).split("/")[0]) +
                                parseInt(getGems(dataFilterPerUser[pageSelected], ["M2_L1", "M2_L2", "M2_L3", "M2_L4", "M2_L5"]).split("/")[0]) +
                                parseInt(getGems(dataFilterPerUser[pageSelected], ["M3_L1", "M3_L2", "M3_L3", "M3_L4"]).split("/")[0]) +
                                parseInt(getGems(dataFilterPerUser[pageSelected], ["M4_L1", "M4_L2", "M4_L3", "M4_L4", "M4_L5"]).split("/")[0])
                            }/12
                        </p>
                    </div>

                </div>
                {/*  */}
                {
                    dataFilterPerUser.length >= 2 &&
                    <div
                        onClick={() => { onchangePage(1) }}
                        className='h-full flex justify-center items-center pl-4 cursor-pointer'>
                        <div className='w-10 h-10 rounded-lg shadowBtnNext flex justify-center items-center'>
                            <img src={icons.mayorqueicon} className='h-6 ' alt="" />
                        </div>
                    </div>
                }
            </div>
            <div className='w-full flex justify-center gap-x-2 pt-4'>
                {dataFilterPerUser.length >= 2 && <PageViewer pageSelected={pageSelected} dataFilterPerUser={dataFilterPerUser.length}></PageViewer>}

            </div>
        </div>
    )
}


const PageViewer = ({ pageSelected, dataFilterPerUser }) => {
    const rows = []
    for (let index = 0; index < dataFilterPerUser; index++) {
        rows.push(
            <div key={index} className={`w-2 h-2 
                ${pageSelected === index ? "bg-[#14A6E0] bg-opacity-100" : "bg-black bg-opacity-40"}
                 rounded-full`}></div>
        )
    }
    return rows
}

const InfoUser = ({ title, text }) => {
    return (
        <div className={`${title === "Fecha y hora de registro" ? "w-3/6" : "w-1/6"} h-full flex`}>
            <p className='text-[#686868]  text-xs font-medium leading-5'>{title}: </p>
            <p className='text-[#454545] text-xs font-normal leading-5 pl-2'>{text}</p>
        </div>
    )
}

const CubeSteap = ({ dataFilterPerUser, pageSelected, steap }) => {
    const responsesSummary = dataFilterPerUser[pageSelected]?.[steap].correct + dataFilterPerUser[pageSelected]?.[steap].incorrect
    return (
        <div className={`w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold 
        ${dataFilterPerUser[pageSelected]?.[steap].incorrect >= 1 ? "bg-[#DF3C3C]" :
            (responsesSummary) === 0 || !responsesSummary ? "bg-[#00000020]" :
                    "bg-[#89EB7E]"}`}>
            {dataFilterPerUser[pageSelected] ? dataFilterPerUser[pageSelected][steap].correct + dataFilterPerUser[pageSelected][steap].incorrect : 'X'}
        </div>
    )
}

const InfoIntent = ({ icon, title, data }) => {
    return (
        <div className='flex gap-2'>
            <img src={icon} className="w-6 h-6" alt="icono de fecha" />
            <div>
                <p className='text-[#686868] text-xs font-medium leading-5'>{title}</p>
                <p className='w-[112px] text-[#9A9A9A] text-xs font-normal leading-5'>{data}</p>
            </div>
        </div>
    )
}


export default UserPerfilCemexVrl